import { HTMLAttributes, memo, ReactElement } from "react";
import { Button } from "./button";
import { useNavigate } from "react-router-dom";

interface Props extends HTMLAttributes<HTMLElement> {
    title?: string;
    subTitle?: string;
    link?: any;
    myStyle?: string;
    hasButn?: Boolean;
    icon?: any;
    colorful?: boolean;
}

export function PolicyInfo({ title, subTitle, link, myStyle, hasButn, colorful, icon }: Props): ReactElement {
    const navigation = useNavigate();
    return (
        <div className={`${myStyle ? myStyle : ""} policy-info`}>
            {icon ? <img className="icon" src={icon} alt="هامرز"/> : null}
            <div className="content">
                <div>
                    <span className="title"> {title}</span>
                    <div className="has-btn">
                        <span className={colorful ? "colorful-subtitle" : "subtitle"}>{subTitle}</span>
                    </div>
                </div>
                {link &&
                    <Button myStyle="custom-button" title=" جزئیات" onClick={()=>link ? navigation(`${link}`) : null} />
                }
            </div>
        </div>
    )
}
export default memo(PolicyInfo);